export const SCORECARD_CREATION_STARTED = "scorecard_creation_started";

export const SCORECARD_CREATE_SELECTED = "scorecard_create_selected";

export const SCORECARD_NEW_QUESTION_STARTED = "scorecard_new_question_started";

export const SCORECARD_NEW_QUESTION_CREATED = "scorecard_new_question_created";

export const SCORECARD_SAVED = "scorecard_saved";
